import { Card, Bleed, Divider, InlineStack, Layout, Page, SkeletonBodyText, SkeletonDisplayText, BlockStack } from "@shopify/polaris";
import React from "react"

export function mappingSkeleton() {
  return (
    <Page><BlockStack gap="500">
      <InlineStack gap="400" blockAlign='start' wrap={false}>
        <div className='header__skeleton--back'>
          <SkeletonDisplayText />
        </div>
        <div className='page_title'>
          <BlockStack gap="200">
            <SkeletonDisplayText />
            <div>
              <SkeletonBodyText lines={2} />
            </div>
          </BlockStack>
        </div>
        <div className="lang_body">
          <BlockStack gap="100">
            <SkeletonBodyText lines={1} />
            <SkeletonDisplayText />
          </BlockStack>
        </div>
      </InlineStack>
      <Layout>
        <Layout.AnnotatedSection title={<SkeletonDisplayText />}>
          <Card roundedAbove="sm">
            <BlockStack gap="400">
              <BlockStack gap="300">
                <SkeletonBodyText lines={3} />
              </BlockStack>
            </BlockStack>
          </Card>
        </Layout.AnnotatedSection>
        <Layout.AnnotatedSection title={<SkeletonDisplayText />} description={<div className='pt-15'><SkeletonBodyText lines={2} /></div>}>
          <Card roundedAbove="sm">
            <BlockStack gap="300">
              <BlockStack gap="200">
                <Card roundedAbove='sm'>
                  <BlockStack gap="400">
                    <SkeletonDisplayText />
                    <SkeletonBodyText lines={1} />
                  </BlockStack>
                </Card>
                <Card roundedAbove='sm'>
                  <BlockStack gap="400">
                    <SkeletonDisplayText />
                    <SkeletonBodyText lines={1} />
                  </BlockStack>
                </Card>
              </BlockStack>
              <InlineStack align='center' gap="500">
                <div className='header__skeleton--back'>
                  <SkeletonDisplayText />
                </div>
                <div className='header__skeleton--back'>
                  <SkeletonDisplayText />
                </div>
              </InlineStack>
            </BlockStack>
          </Card>
        </Layout.AnnotatedSection>
      </Layout>
    </BlockStack>
    </Page>
  );
}

export function productType() {
  return <>
    <InlineStack align='space-between' blockAlign='center' gap="100">
      <div className="product_type--head">
        <SkeletonBodyText lines={1} />
      </div>
      <div className="product__button">
        <SkeletonDisplayText />
      </div>
    </InlineStack>
    <Bleed marginInline="500"><Divider /></Bleed>
    <div className="product__button">
      <SkeletonDisplayText />
    </div>
  </>;
}